import { Container } from "./styles";


export function WizardDiv(props: any) {
    return <Container>{props.children}</Container>;
  }
  